import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Webhook extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Webhook'
  // Define default properties here
  static instanceDefaults() {
    return {
      type: null,
      member_id: null,
      group_id: null,
      action_id: null,
      message: {},
      elaborated: null,
      data: {},
      success: null,
      error: null,
      created_at: null,
      sent_at: null
    }
  }
}

const servicePath = 'webhooks'
const servicePlugin = makeServicePlugin({
  Model: Webhook,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin